<template>
    <module-navigator class="mb-3" :nav-opts="navOpts" />
</template>
<script>
import moduleNavigator from '../custom/moduleNavigator.vue';
import {rootName as requestcacheName } from './router.js';
import {rootName as webhookName } from '../Webhook/router.js';
export default {
    name: 'navigatorWebhookAndRequestcache',
    components: {
        moduleNavigator
    },
    props: {
        navOpts: {
            type: Array,
            default: () => [requestcacheName, webhookName]
        }
    }
}
</script>